import React, { Suspense } from 'react';
import { Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import routesObj, { RouteConfig } from './routes';
import { ProgressProvider } from '../contextAPI/progressContext';
import { ValueProvider } from '../contextAPI/scoreDiscount';
import { ScoreProvider } from '../contextAPI/scoreContext';

const CustomRoutesConfig: React.FC = () => {
  return (
    <Router>
      <ValueProvider>
        <ProgressProvider>
          <ScoreProvider>
            <Suspense fallback={<div className="loader">
              <div className="loader-wheel"></div>
              <div className="loader-text"></div>
            </div>}>
              <Routes>
                {routesObj.map((route: RouteConfig, index: number) => (
                  <Route
                    key={index}
                    path={route.path}
                    Component={route.component}
                  />
                ))}
              </Routes>
            </Suspense>
          </ScoreProvider>
        </ProgressProvider>
      </ValueProvider>
    </Router>
  );
};

export default CustomRoutesConfig;

